import React, { useState, useEffect, useRef } from "react";
import FontPicker from "font-picker-react";
import TabbedPanel from "../../../../components/TabbedPanel/TabbedPanel";
import FormDropDown from "../../../../components/forms/DropDownList/FormDropDown";
import { applyFontPreview, FontPreviewBlock, getCustomFontUrl } from "../../../../helpers/CustomFonts";
import { slideOutPanelControl } from "../SlideoutPanel";
import './FontSelectorContent.scss';

const FontSelectorContent = (props) => {
    const customFonts = props.customFonts || [];
    const campaignId = props.campaignId;
    const [busy, setBusy] = useState(false);

    const isCustomFont = (fontFamily) => {
        if (customFonts) {
            const font = customFonts.find(f => f.fontFamily === fontFamily);
            return font ? true : false;
        }
        return false;
    }

    const [activeFontFamily, setActiveFontFamily] = useState(props.currentFont || 'Roboto');
    const [activeGoogleFont, setActiveGoogleFont] = useState(isCustomFont(props.currentFont) ? 'Roboto' : props.currentFont);
    const [activeCustomFont, setActiveCustomFont] = useState(isCustomFont(props.currentFont) ? props.currentFont : (customFonts?.[0]?.fontFamily ?? ''));
    
    const initialTab = isCustomFont(props.currentFont) ? 'custom' : 'google';
    const [currentTab, setCurrentTab] = useState(initialTab);

    const tabData = [
        { label: 'Google Fonts', id: 'google' },
        { label: 'Custom Fonts', id: 'custom', hidden: (!customFonts || customFonts.length === 0) }
    ];

    const customFontsDropdown = customFonts.map ? customFonts.map(f => ({ label: f.fontFamily, value: f.fontFamily, fontFile: f.fontFilename })) : [];
    // Show currently active custom font as selected, or -1 if Google font is active
    const currentCustomFontIndex = isCustomFont(activeFontFamily) ? customFontsDropdown.findIndex(f => f.value === activeFontFamily) : -1;

    const applyCustomFontToPreview = (fontData = null) => {
        if (!customFonts || customFonts.length === 0) {
            return;
        }

        if (fontData === null) {
            fontData = customFontsDropdown[currentCustomFontIndex];
        }
        applyFontPreview(fontData.value, getCustomFontUrl(fontData.fontFile, campaignId));
    }

    // Update parent with font changes for preview
    useEffect(() => {
        if (props.isOpenCanMakeChanges && props.onFontChanged && activeFontFamily && activeFontFamily !== props.currentFont) {
            props.onFontChanged(activeFontFamily);
        }
    }, [activeFontFamily, props.isOpenCanMakeChanges]);

    // Handle panel close/confirm
    useEffect(() => {
        if (!props.isOpen && props.onFontSelected && activeFontFamily && activeFontFamily !== props.currentFont) {
            props.onFontSelected(activeFontFamily);
        }
    }, [props.isOpen]);

    useEffect(() => {
        if (currentTab === 'custom') {
            applyCustomFontToPreview();
        }
    }, []);

    const handleTabSwitch = (tabId, tabData) => {
        setCurrentTab(tabData.id);
        // Don't auto-select fonts when switching tabs
        // Let user explicitly choose from each tab
    };

    const handleGoogleFontChange = (nextFont) => {
        setActiveFontFamily(nextFont.family);
        setActiveGoogleFont(nextFont.family);
        // Apply font selection immediately
        if (props.onFontSelected) {
            props.onFontSelected(nextFont.family);
        }
    };

    const handleCustomFontChange = (e, id, item) => {
        setActiveFontFamily(item.value); 
        setActiveCustomFont(item.value);
        applyCustomFontToPreview(item);
        // Apply font selection immediately
        if (props.onFontSelected) {
            props.onFontSelected(item.value);
        }
    };

    return (
        <div className="font-selector-content">
            <TabbedPanel
                tabs={tabData}
                switchTabCallback={handleTabSwitch}
                initialTab={tabData.findIndex(t => t.id === initialTab)}
                tabWidth="50%"
                tabStyle={2}
            >
                <>
                    {currentTab === 'google' && (
                        <div className="fl-column font-selector-tab-content">
                            <FontPicker
                                apiKey="AIzaSyCK-FT-TdFUvWTWBQ_hxsoU_HS6GHeytWg"
                                activeFontFamily={isCustomFont(activeFontFamily) ? 'Select a Google font' : activeFontFamily}
                                limit={100}
                                onChange={handleGoogleFontChange}
                            />
                            <FontPreviewBlock className="apply-font" />
                        </div>
                    )}
                    {currentTab === 'custom' && (
                        <div className="fl-column font-selector-tab-content">
                            <FormDropDown
                                id="customFonts"
                                label="Custom Fonts"
                                showLabel={false}
                                showErrors={false}
                                currentIndex={currentCustomFontIndex >= 0 ? currentCustomFontIndex : 0}
                                selectFunc={handleCustomFontChange}
                                items={currentCustomFontIndex >= 0 ? customFontsDropdown : [{ label: "Select a custom font", value: "", disabled: true }, ...customFontsDropdown]}
                            />
                            <FontPreviewBlock className="apply-custom-font" />
                        </div>
                    )}
                </>
            </TabbedPanel>
        </div>
    );
}

export default FontSelectorContent;